import React, { Component } from 'react';
import DateInput from './dateInput';
import TextInput from './textInput';
import DynamicListInput from '../forms/dynamicListInput';

const ExtendedPropertyCreator = (props) => {
	var renderProperties = [];
	var inputs = [];

	if(props.extendedProperties) {
        props.extendedProperties.map(function(item, i) {
          	var extendedProperty = item;    
          	var value = "";   
          	
          	if(props.extendedPropertiesValue) {
          		for(var j=0; j<props.extendedPropertiesValue.length;j++) {
          			if(props.extendedPropertiesValue[j].id==item.id) {
          				value = props.extendedPropertiesValue[j].value;
          			}
          		}
          	}          	
          	//SPECIAL CASE FOR SEMI TRAILER
          	if(extendedProperty.crud=="semitrailer" &&
          		extendedProperty.dataType=="TEXT" &&
          		extendedProperty.name.toUpperCase()=="TIPO") {
				inputs.push(<DynamicListInput
					id={props.prefix + "extended-property-" + extendedProperty.id}
					dataUpdate={"vehicleType-"+extendedProperty.id}
					value={value}
					list={props.lists["SEMITRAILER TYPE"]}
					className="modal-input"
					onClickHandler={props.onChange}
					emptyValue={"Sin tipo"}
				/>);
          	}
            else {
			    switch (extendedProperty.dataType) {      
			      	case "DATE" :
			      		inputs.push(
	  			        	<DateInput
								date={value}
								id={props.prefix + "extended-property-" + extendedProperty.id}
							/>
			      		);
			      		break;
		        	default:
			      		inputs.push(
	  			        	<TextInput
								value={props.extendedPropertiesValue ? value : null}
								id={props.prefix + "extended-property-" + extendedProperty.id}
								onChange={props.onChange}
								extendedPropertyId={extendedProperty.id}
							/>
			      		);		      		
			      		break;
		      	}
	      	}
	      	renderProperties.push((
	          <div key={props.prefix + i} className="box-form islabel">
	            <div>
	              <label className="modal-label">
	                {extendedProperty.name}
	              </label>
	            </div>
	            <div>
	              {inputs[i]}
	            </div>
	          </div>
	      	));
        });
	}

	return (
		<div>{renderProperties}</div>
	);
};
  
export default ExtendedPropertyCreator;


// WEBPACK FOOTER //
// ./source/client/components/common/extended_property/extendedPropertyCreator.jsx